module.exports = __webpack_public_path__ + "img/phone-version-2.dc52a6c9.svg";